// src/api/loginAgreementConsentService.js

// Shared Axios client (baseURL, JWT, interceptors)
import api from "./api";

// Backend controller base path:
// Your controller uses:
// [Route("api/login-agreement-consents")]
// therefore baseURL/api + "/login-agreement-consents"
const API_URL = "/login-agreement-consents";

// ---------------------------
// CREATE consent (POST /accept)
// ---------------------------
export const createLoginAgreementConsent = async (data) =>
    (await api.post(`${API_URL}/accept`, data)).data;

// ---------------------------
// GET all consents
// ---------------------------
export const getLoginAgreementConsents = async () =>
    (await api.get(API_URL)).data;

// ---------------------------
// GET single consent by id
// ---------------------------
export const getLoginAgreementConsent = async (id) =>
    (await api.get(`${API_URL}/${id}`)).data;

// ---------------------------
// UPDATE consent (PUT /{id})
// 🔥 added specifically for your page
// ---------------------------
export const updateLoginAgreementConsent = async (id, data) =>
    (await api.put(`${API_URL}/${id}`, data)).data;

// ---------------------------
// DELETE consent
// ---------------------------
export const deleteLoginAgreementConsent = async (id) =>
    (await api.delete(`${API_URL}/${id}`)).data;

// ---------------------------
// Default export
// ---------------------------
export default {
    createLoginAgreementConsent,
    getLoginAgreementConsents,
    getLoginAgreementConsent,
    updateLoginAgreementConsent,
    deleteLoginAgreementConsent,
};
